import { Component, ElementRef, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { ApiService } from '@app/utility/api.service'
import { UtilService } from '@app/utility/util.service'
import { ExcelService } from '@app/excel.service'
import { forkJoin } from 'rxjs/observable/forkJoin';
import { Observable } from 'rxjs';

declare var $: any, moment: any
declare function unescape(s: string): string;

@Component({
  selector: 'app-report',
  templateUrl: './report.component.html',
  styleUrls: ['./report.component.scss']
})
export class ReportComponent implements OnInit {

  agentList: any = []

  role: any = {}
  cookieData: any

  caseChannelList: any
  caseStatusList: any
  caseSeverityList: any

  // smsTmpList: any
  // emailTmpList: any
  caseTypeList: any
  subTypeTmpList: any
  caseSubTypeList: any = []
  teamList: any

  totalHigh: number = 0
  totalMedium: number = 0
  totalLow: number = 0

  criCaseType = ""
  criCaseSubType = ""
  criChannel = ""
  criStatus = ""
  criSLA = ""
  criPriority = ""
  criCreate = ""
  criModify = ""
  
  criCallcenterteam = ""

  myTeams: any

  reportList: any = []

  dtReport: any = null

  createDateFromObj: any
  createDateToObj: any
  updateDateFromObj: any
  updtaeDateToObj: any

  @ViewChildren('tbR') tbR: QueryList<any>;
  @ViewChild('criFromCreateDate') criFromCreateDate: ElementRef
  @ViewChild('criToCreateDate') criToCreateDate: ElementRef
  @ViewChild('criFromModifyDate') criFromModifyDate: ElementRef
  @ViewChild('criToModifyDate') criToModifyDate: ElementRef

  constructor(
    private util: UtilService,
    private apiService: ApiService,
    private excel: ExcelService

  ) {
  }

  async ngOnInit() {
    this.util.ShowWaiting(true)
    let thisTs = this

    this.cookieData = JSON.parse(localStorage.getItem("dpa_cc"))
    this.role = JSON.parse(this.cookieData.role)
    this.myTeams = JSON.parse(this.cookieData.teams)

    this.callApi()
    //await this.initDropdown()

    $(".select2").select2();

    $(thisTs.criFromCreateDate.nativeElement).on('changeDate', function (ev: any) {
      thisTs.createDateFromObj = ev.date
      $(thisTs.criToCreateDate.nativeElement).datepicker('setStartDate', ev.date);
      if(thisTs.createDateToObj){
        $(thisTs.criToCreateDate.nativeElement).datepicker('setDate', thisTs.createDateToObj);
      }
    });
    $(thisTs.criToCreateDate.nativeElement).on('changeDate', function (ev: any) {
      thisTs.createDateToObj = ev.date
      $(thisTs.criFromCreateDate.nativeElement).datepicker('setEndDate', ev.date);
      if(thisTs.createDateFromObj){
        $(thisTs.criFromCreateDate.nativeElement).datepicker('setDate', thisTs.createDateFromObj);
      }
    });
    $(thisTs.criFromModifyDate.nativeElement).on('changeDate', function (ev: any) {
      thisTs.updateDateFromObj = ev.date
       $(thisTs.criToModifyDate.nativeElement).datepicker('setStartDate', ev.date);
       if(thisTs.updtaeDateToObj){
         $(thisTs.criToModifyDate.nativeElement).datepicker('setDate', thisTs.updtaeDateToObj);
       }
    });
    $(thisTs.criToModifyDate.nativeElement).on('changeDate', function (ev: any) {
      thisTs.updtaeDateToObj = ev.date
       $(thisTs.criFromModifyDate.nativeElement).datepicker('setEndDate', ev.date);
       if(thisTs.updateDateFromObj){
         $(thisTs.criFromModifyDate.nativeElement).datepicker('setDate', thisTs.updateDateFromObj);
       }
    });

    this.util.ShowWaiting(false)
  }

  callApi(): Observable<any> {
    return forkJoin([
      this.initDropdown()
    ]);
  }

  async initDropdown() {
    
    if(this.myTeams != null && this.myTeams.length > 0){
      let para = ""
      this.myTeams.forEach((t: any) => {
        if(para != ""){
          para += "&"
        }     
        para += "callcenterteam=" + t.dpa_callcenterteamid
      });
      this.agentList = await this.apiService.get("crmservice", "callcenterProfile", para)
      // let agents: any = tmp.filter((t: any) => { return t.dpa_teamidlist != null && t.dpa_teamidlist.length > 0})

      // this.myTeams.forEach((t: any) => {
      //   agents.forEach((a: any) => {
      //     if (this.agentList.indexOf(a) == -1) {
      //       let match: any = a.dpa_teamidlist.filter((at: any) => {
      //         return at.dpa_callcenterteamid == t.dpa_callcenterteamid
      //       })

      //       if (match != null && match.length > 0) {
      //         this.agentList.push(a)
      //       }
      //     }
      //   })
      // });
    }

    this.caseChannelList = await this.apiService.get("master", "caseChannel")
    this.caseStatusList = await this.apiService.get("master", "caseStatus")
    this.caseSeverityList = await this.apiService.get("master", "caseSeverity")
    this.caseTypeList = await this.apiService.get("master", "caseType")
    this.subTypeTmpList = await this.apiService.get("master", "caseSubType")

    let teams: any = await this.apiService.get("master", "callcenterTeam")
    this.teamList = teams.filter((t: any) => {
      return this.myTeams.map((mt: any) => { return mt.dpa_callcenterteamid }).indexOf(t.dpa_callcenterteamid) > -1
    })
    
    this.util.ShowWaiting(false)
  }

  onCaseTypeChange() {
    if (this.criCaseType != null && this.criCaseType.length > 0) {
      this.caseSubTypeList = this.subTypeTmpList.filter(
        (subType: any) => subType.dpa_casetypeid === this.criCaseType)
    }
  }

  resetCriteriaForm() {
    this.criCaseType = ""
    this.criCaseSubType = ""
    this.criChannel = ""
    this.criStatus = ""
    this.criSLA = ""
    this.criPriority = ""
    this.criCreate = ""
    this.criModify = ""

    $('[data-provide="datepicker"]').val("").datepicker("update");
  }

  async search() {
    let para = ""
    let fromCreateDt = $(this.criFromCreateDate.nativeElement).val();
    let toCreateDt = $(this.criToCreateDate.nativeElement).val();
    let fromModifyDt = $(this.criFromModifyDate.nativeElement).val();
    let toModifyDt = $(this.criToModifyDate.nativeElement).val();

    if (this.criChannel != null && this.criChannel != "") {
      para += (para.length > 0 ? "&" : "") + "case_channel=" + this.criChannel
    }
    if (this.criCaseType != null && this.criCaseType != "") {
      para += (para.length > 0 ? "&" : "") + "case_type=" + this.criCaseType
    }
    if (this.criCaseSubType != null && this.criCaseSubType != "") {
      para += (para.length > 0 ? "&" : "") + "case_subtype=" + this.criCaseSubType
    }
    if (this.criStatus != null && this.criStatus != "") {
      para += (para.length > 0 ? "&" : "") + "case_status=" + this.criStatus
    }
    if (this.criPriority != null && this.criPriority != "") {
      para += (para.length > 0 ? "&" : "") + "case_priority=" + this.criPriority
    }
    if (this.criSLA != null && this.criSLA != "") {
      para += (para.length > 0 ? "&" : "") + "case_sla=" + this.criSLA
    }
    if (fromCreateDt != null && fromCreateDt != "") {
      para += (para.length > 0 ? "&" : "") + "case_date_from=" + moment($(this.criFromCreateDate.nativeElement).data('datepicker').date).format("YYYY-MM-DD")
    }
    if (toCreateDt != null && toCreateDt != "") {
      para += (para.length > 0 ? "&" : "") + "case_date_to=" + moment($(this.criToCreateDate.nativeElement).data('datepicker').date).format("YYYY-MM-DD")
    }
    if (fromModifyDt != null && fromModifyDt != "") {
      para += (para.length > 0 ? "&" : "") + "case_modified_from=" + moment($(this.criFromModifyDate.nativeElement).data('datepicker').date).format("YYYY-MM-DD")
    }
    if (toModifyDt != null && toModifyDt != "") {
      para += (para.length > 0 ? "&" : "") + "case_modified_to=" + moment($(this.criToModifyDate.nativeElement).data('datepicker').date).format("YYYY-MM-DD")
    }
    if (this.criCreate != null && this.criCreate != "") {
      para += (para.length > 0 ? "&" : "") + "createby=" + this.criCreate
    }
    if (this.criModify != null && this.criModify != "") {
      para += (para.length > 0 ? "&" : "") + "modifiedby=" + this.criModify
    }

    if (this.criCallcenterteam != null && this.criCallcenterteam != "") {
      para += (para.length > 0 ? "&" : "") + "callcenterteam=" + this.criCallcenterteam
    }
    else {
      if(this.myTeams != null && this.myTeams.length > 0){
        this.myTeams.forEach((t: any) => {
          para += (para.length > 0 ? "&" : "") + "callcenterteam=" + t.dpa_callcenterteamid
        });
      }
    }

    let filteredList: any
    if (para.length > 0) {
      filteredList = await this.apiService.get("crmservice", "summaryCaseReport", para)
    }
    else {
      filteredList = await this.apiService.get("crmservice", "summaryCaseReport")
    }

    return filteredList
  }

  async view() {
    this.util.ShowWaiting(true)

    $('#tbReport').DataTable().clear().destroy();

    this.reportList = await this.search()
    this.totalHigh = this.totalMedium = this.totalLow = 0
    this.reportList.forEach((r: any) => {
      if (r.dpa_caseseverityidname != null && r.dpa_caseseverityidname.toLocaleLowerCase() == "high") {
        this.totalHigh++
      }
      else if (r.dpa_caseseverityidname != null && r.dpa_caseseverityidname.toLocaleLowerCase() == "medium") {
        this.totalMedium++
      }
      else if (r.dpa_caseseverityidname != null && r.dpa_caseseverityidname.toLocaleLowerCase() == "low") {
        this.totalLow++
      }
    });
    this.util.ShowWaiting(false)
  }

  async exportExcel() {
    this.util.ShowWaiting(true)
    let tmpResultList = await this.search()

    let resultList: any = []
    tmpResultList.forEach((r: any) => {
      let rowData: any = {
        //Priority: r.dpa_caseseverityidname,
        SLA: r.dpa_issla ? 'Over' : '',
        CaseID: r.ticketnumber,
        ชื่อ: r.firstname,
        นามสกุล: r.lastname,
        หมายเลขโทรศัพท์: r.telephone1,
        ช่องทางการติดต่อ: r.dpa_casechannelidname,
        ประเภทรายงานการติดต่อ: r.dpa_casetypeidname,
        หัวข้อการติดต่อ: r.dpa_casesubtypeidname,
        รายละเอียด: r.description,
        คำตอบ: r.dpa_resolution,
        PDPA: r.dpa_pdpa_flag,
        สถานะ: r.dpa_casestatusidname,
        วันที่สร้าง: r.createdon == null ? "" : moment(r.createdon.replace("Z", "")).format('DD/MM/YYYY HH:mm:ss'),
        ผู้ที่สร้าง: r.dpa_createdby,
        วันที่แก้ไขล่าสุด: r.modifiedon == null ? "" : moment(r.modifiedon.replace("Z", "")).format('DD/MM/YYYY HH:mm:ss'),
        ผู้ที่แก้ไข: r.dpa_modifiedby
      }
      resultList.push(rowData)
    });

    //this.excel.exportAsExcelFile(resultList, "report")
    this.TableExcelReport(resultList, "report")

    // const dataWS = XLSX.utils.json_to_sheet(content)
    //   const wb = XLSX.utils.book_new()
    //   XLSX.utils.book_append_sheet(wb, dataWS)
    //   XLSX.writeFile(wb,'export.xlsx')
    this.util.ShowWaiting(false)

  }

  ngAfterViewInit() {
    this.tbR.changes.subscribe(t => {
      this.initTableReport()
    })
  }

  ngForRendred() {
    console.log('NgFor is Rendered');
    if (this.dtReport == null) {
      this.initTableReport()
    }
  }

  initTableReport() {
    this.dtReport = $("#tbReport").dataTable({
      retrieve: true,
      "searching": false,
      "language": {
        "paginate": {
          "previous": "<",
          "next": ">"
        }
      }
    });

  }

  TableExcelReport(form_data: any, filename: any) {
    if (form_data != null) {
      if (form_data.length > 0) {

        let tab_text: string = '<table border="1" ><thead><tr style="background-color: #BEE762">';

        for (var key in form_data[0]) {
          tab_text += "<th>" + key + "</th>";
        }

        tab_text += "</tr></thead><tbody>";

        for (var i = 0; i < form_data.length; i++) {
          tab_text += "<tr>";
          for (var key in form_data[i]) {
            if (form_data[i][key] == null) {
              tab_text += "<td></td>";
            }
            else {
              tab_text += "<td>" + form_data[i][key] + "</td>";
            }
          }
          tab_text += "</tr>";
        }
        tab_text += "</tbody></table>";

        var uri = 'data:application/vnd.ms-excel;base64,'
          , template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--><meta http-equiv="content-type" content="text/plain; charset=UTF-8"/></head><body><table>{table}</table></body></html>'
          , base64 = function (s: any) {
            return window.btoa(unescape(encodeURIComponent(s)))
          }
          , format = function (s: any, c: any) { return s.replace(/{(\w+)}/g, function (m: any, p: any) { return c[p]; }) }
        var ctx = { worksheet: "a" || 'Worksheet', table: tab_text }
        window.location.href = uri + base64(format(template, ctx))
      } else {
        this.util.ErrorDialog('ไม่พบข้อมูล');
      }
    } else {
      this.util.ErrorDialog('ไม่พบข้อมูล');
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/report/report.component.ts